export const createStyles = (theme: any) => {
  const { palette } = theme;

  return {
    button: {
      color: palette.primary.main,
      borderRadius: '0.25rem',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '0.5rem',
      fontSize: '1rem',
      fontWeight: 500,
      '&:hover': {
        backgroundColor: palette.action.hover,
        color: palette.primary.main,
      },
    },
    label: {
      fontSize: '15px',
      fontWeight: 500,
      lineHeight: '26px',
      letterSpacing: '0px',
      color: palette.primary.main,
    },
  };
};
